import React, { useEffect, useState } from "react";
import '../Style/Transactions.css';
import judicialLogo from '../Images/judicialLogo.png';
import { useDispatch, useSelector } from "react-redux";
import { getAllTransactions, openshowTransactionDialog, selectedTransaction } from "../Redux/Dashboard/DashboardSlice";
import Spinner from "../Spinner/Spinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const TransactionsList = () => {
    const dispatch = useDispatch();
    const selector = useSelector((s) => s.DashboardSlice);
    const getTransactions = selector.getTransactions || [];
    const loader = selector.loader;

    const [currentPage, setCurrentPage] = useState(1);
    const transactionsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");

    // Filter transactions with null checks
    const filteredTransactions = getTransactions.filter((txn) => {
        const name = txn.user_id?.name || '';
        const email = txn.user_id?.email || '';
        const phone = txn.user_id?.phone || '';
        const courseTitle = txn.course_id?.title || '';
        return (
            name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            courseTitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
            phone.includes(searchTerm)
        );
    }).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) || [];

    // Pagination logic
    const totalPages = Math.ceil(filteredTransactions.length / transactionsPerPage);
    const indexOfLast = currentPage * transactionsPerPage;
    const indexOfFirst = indexOfLast - transactionsPerPage;
    const currentTransactions = filteredTransactions.slice(indexOfFirst, indexOfLast);

    const nextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const prevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleView = (txn) => {
        dispatch(selectedTransaction(txn));
        dispatch(openshowTransactionDialog(true));
    };

    useEffect(() => {
        dispatch(getAllTransactions());
    }, [dispatch]);

    return (
        <div className="transactions-list-main">
            <img className="judicial-logo" src={judicialLogo} alt="Judicial Logo" />
            <h2 className="text-white">Transactions List ({getTransactions.length})</h2>

            <div className="controls">
                <div className="search-container">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    <input
                        type="text"
                        placeholder="Search by name, email, phone, or course..."
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                        className="search-input"
                    />
                </div>
            </div>

            <div className="table-container">
                <table className="transactions-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Course</th>
                            <th>Course Amount</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {loader ? (
                        <tbody>
                            <tr>
                                <td colSpan="8">
                                    <div className="spinner-wrapper">
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {currentTransactions.length > 0 ? (
                                currentTransactions.map((txn, index) => (
                                    <tr key={index}>
                                        <td>{txn.enrolled_at ? new Date(txn.enrolled_at).toLocaleDateString() : '-'}</td>
                                        <td>{txn.user_id?.name || '-'}</td>
                                        <td>{txn.user_id?.email || '-'}</td>
                                        <td>{txn.user_id?.phone || '-'}</td>
                                        <td>{txn.course_id?.title || '-'}</td>
                                        <td>{txn.payment_id?.amount ? `₹${txn.payment_id.amount}` : '-'}</td>
                                        <td>{txn.payment_id?.payment_status || '-'}</td>
                                        <td>
                                            <button
                                                className="action-btn view-btn"
                                                onClick={() => handleView(txn)}
                                            >
                                                View Details
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="no-data">
                                        No transactions found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>

            {!loader && totalPages > 1 && (
                <div className="pagination">
                    <button onClick={prevPage} disabled={currentPage === 1}>
                        <FontAwesomeIcon icon={faChevronLeft} /> Prev
                    </button>
                    <span>Page {currentPage} of {totalPages}</span>
                    <button onClick={nextPage} disabled={currentPage === totalPages}>
                        Next <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default TransactionsList;